import React, { Component } from 'react';
import { captureException } from '@sentry/react';
import { getTheme } from '@Thread-Magic/jasmine';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null, errorInfo: null };
  }

  componentDidCatch = (error, errorInfo) => catchFunc(error, errorInfo, this);

  render() {
    if (this.state.errorInfo) {
      return handleError(this);
    }
    // Normally, just render children
    return this.props.children;
  }
}

export const withErrorBoundary = WrappedComponent =>
  class extends Component {
    constructor(props) {
      super(props);
      this.state = {};
    }

    componentDidCatch(error, errorInfo) {
      catchFunc(
        error,
        errorInfo,
        this,
        WrappedComponent?.displayName || WrappedComponent?.type?.displayName
      );
    }

    render() {
      // by default react will try to hide only broken components
      // and display the ones with no error
      return <WrappedComponent {...this.props} />;
    }
  };

const catchFunc = (error, errorInfo, ctx, displayName) => {
  // catch errors in any components below and report
  captureException(new Error(`Fatal rendering error ${displayName}: ${error.message}`), {
    extra: { errorInfo, ctx }
  });
};

const handleError = ctx => (
  // Error path
  <div style={ctx.props.style || styles.error}>
    <h2>Something went wrong.</h2>
    <details style={{ whiteSpace: 'pre-wrap' }}>
      {ctx.state.error && ctx.state.error.toString()}
      <br />
      {ctx.state.errorInfo.componentStack}
    </details>
  </div>
);

const styles = {
  error: {
    backgroundColor: getTheme().colors.red2,
    borderTop: `1px solid ${getTheme().colors.gray6}`,
    borderBottom: `1px solid ${getTheme().colors.gray6}`,
    padding: '12px'
  }
};
